import moment from 'moment';
import React, { Component, Fragment } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { get } from '../../../server/actions';
import { showFile, _addNotificationError } from '../../../server/util';
import { getLoginDistrictInfo } from '../../../server/utilDistrict';
import './customReactDatepicker.css';
import './reports.css';
import ClaimReportIcon from './../../../assets/img/mm/icon-2.png';
import { cepReimbursementClime, cepReimbursementClimeDistrict } from './cepServices';

class CEPClaim extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedMonth: props.reportDefaultDate || new Date(),
            startDate: props.reportDefaultDate || new Date(),
            endDate: props.reportDefaultDate || new Date(),
            data: [],
            loading: false,
            userInfo: getLoginDistrictInfo(),
        }
    }
    componentWillUnmount = () => {
        // this.bindData();
    }
    bindData = () => {
        const districtID = this.state.userInfo.districtId;
        let schoolID = parseInt(this.props.selectSchool);
        const s_d_id = schoolID > 0 ? schoolID : districtID;
        const isSchool = schoolID > 0 ? true : false;
        const schoolYear = this.props.selectedSchoolYear || this.state.userInfo.schools[0].activeSchoolYear;
        let start = moment(this.state.startDate).format('YYYY-MM-DD') + "T00:00:00";
        let end = moment(this.state.endDate).format('YYYY-MM-DD') + "T23:59:59";
        let yearMonth = moment(this.state.selectedMonth).format('YYYYMM');
        this.setState({ loading: true });
        (schoolID > 0 ? cepReimbursementClime({
            schoolId: schoolID,
            districtId: districtID,
            schoolYear: schoolYear,
            start: moment(start, 'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss"),
            end: moment(end, 'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss"),
            mealType: this.state.mealType,
            yearMonth: yearMonth
        }) :
            cepReimbursementClimeDistrict({
                districtId: districtID,
                schoolYear: schoolYear,
                start: moment(start, 'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss"),
                end: moment(end, 'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss"),
                mealType: this.state.mealType,
                yearMonth: yearMonth
            })).then((response) => {
                if (!response.ok) {
                    if (response.status === 417 || response.status === 422) {
                        return response.json();
                    }
                }
                console.log('response', response);
                return response;
            }).then(res => {
                if (res.statusCode === 417) {
                    _addNotificationError(res.statusMessage, this.props)
                    throw Error(res.errorMessage);
                } else if (res.statusCode === 422) {
                    throw Error(res.statusMessage);
                } else {
                    return res.blob();
                }
            }).then(blob => {
                let filename = "BasicClaimReport";
                showFile(blob, filename);
                this.setState({ loading: false })
            }).catch((error) => {
                let msg = ''
                if (typeof error === 'string') {
                    msg = error;
                } else {
                    msg = error.message;
                }
                _addNotificationError(msg, this.props);
                this.setState({ loading: false })
            }
            );
    }
    render() {
        const { startDate, endDate, selectedMonth } = this.state;
        const monthStart = moment(selectedMonth).startOf('month').toDate();
        const monthEnd = moment(selectedMonth).endOf('month').toDate();
        return (
            <Fragment>
                <div className="reportCard reportCard-margin">
                    <div className="reportCard-body">
                        <div className="reportCard-widget">
                            <div className="reportCard-widget-title-wrapper">
                                <div className="reportCard-widget-date-primary">
                                    <img src={ClaimReportIcon} />
                                </div>
                                <div className="reportCard-widget-meeting-info">
                                    <span className="reportCard-widget-pro-title color-3"><b>CEP Basic Claim</b></span>
                                </div>
                            </div>
                            <div className="reportCard-widget-meeting-points">
                                <div className="row form-group">
                                    <label class="col-sm-12 control-label">Select Month</label>
                                    <div className="col-sm-12">
                                        <DatePicker wrapperClassName="fullWidthDatepicker"
                                            selected={selectedMonth}
                                            showMonthYearPicker
                                            dateFormat="MMM-yyyy"
                                            onChange={(date) => {
                                                this.setState({
                                                    selectedMonth: date,
                                                    startDate: moment(date).startOf('month').toDate(),
                                                    endDate: moment(date).endOf('month').toDate()
                                                });
                                            }} className='form-control form-control-sm' />
                                    </div>
                                </div>
                                <div className="row form-group">
                                    <label class="col-sm-12 control-label">Start Date</label>
                                    <div className="col-sm-12">
                                        <DatePicker wrapperClassName="fullWidthDatepicker"
                                            selected={startDate}
                                            minDate={monthStart}
                                            maxDate={monthEnd}
                                            onChange={(date) => {
                                                this.setState({ startDate: date });
                                            }} className='form-control form-control-sm' />
                                    </div>
                                </div>
                                <div className="row form-group">
                                    <label class="col-sm-12 control-label">End Date</label>
                                    <div className="col-sm-12">
                                        <DatePicker wrapperClassName="fullWidthDatepicker"
                                            selected={endDate}
                                            minDate={monthStart}
                                            maxDate={monthEnd}
                                            onChange={(date) => {
                                                this.setState({ endDate: date });
                                            }} className='form-control form-control-sm' />
                                    </div>
                                </div>
                                <div className='reportCard-widget-meeting-action'>
                                    <div className="form-group">
                                        <button type='button' className='btn btn-sm btn-success' style={{ margin: '0px' }} onClick={() => {
                                            this.bindData()
                                        }}>
                                            Download Report
                                        </button>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>



                </div>
            </Fragment>
        );
    }
}

export default CEPClaim;


// WEBPACK FOOTER //
// ./src/components/District/Reports/cepClaim.js